<template>
  <pt-fast-loan-audit-detail class="pt-fast-loan-audit-detail__page" :id="id"></pt-fast-loan-audit-detail>
</template>

<script>
import PtFastLoanAuditDetail from 'cps/new-to-old-audit/pt-fast-loan-audit/pt-fast-loan-audit-detail/withData'
export default {
  name: 'pt-fast-loan-audit-detail__view',
  components: {
    'pt-fast-loan-audit-detail': PtFastLoanAuditDetail
  },
  props: {
    id: {
      type: String,
      default: ''
    }
  }
}
</script>
